// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: gxplQWBh0N

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import AttentionSelectionElement from "../../AttentionSelectionElement"; // plasmic-import: AN4lA4Fd1A/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicAttentionSelection.module.css"; // plasmic-import: gxplQWBh0N/css

import Iconinfo2Icon from "./icons/PlasmicIcon__Iconinfo2"; // plasmic-import: BWVpjBn8gv/icon

createPlasmicElementProxy;

export type PlasmicAttentionSelection__VariantMembers = {
  saveButton: "saveButton";
};
export type PlasmicAttentionSelection__VariantsArgs = {
  saveButton?: SingleBooleanChoiceArg<"saveButton">;
};
type VariantPropType = keyof PlasmicAttentionSelection__VariantsArgs;
export const PlasmicAttentionSelection__VariantProps =
  new Array<VariantPropType>("saveButton");

export type PlasmicAttentionSelection__ArgsType = {};
type ArgPropType = keyof PlasmicAttentionSelection__ArgsType;
export const PlasmicAttentionSelection__ArgProps = new Array<ArgPropType>();

export type PlasmicAttentionSelection__OverridesType = {
  root?: p.Flex<"div">;
  attentionSelection?: p.Flex<"div">;
  attentionPriorityLevels?: p.Flex<"div">;
  bars?: p.Flex<"div">;
  grey?: p.Flex<typeof AttentionSelectionElement>;
  yellow?: p.Flex<typeof AttentionSelectionElement>;
  orange?: p.Flex<typeof AttentionSelectionElement>;
  red?: p.Flex<typeof AttentionSelectionElement>;
  purple?: p.Flex<typeof AttentionSelectionElement>;
  infoButton?: p.Flex<"svg">;
};

export interface DefaultAttentionSelectionProps {
  saveButton?: SingleBooleanChoiceArg<"saveButton">;
  className?: string;
}

const $$ = {};

function PlasmicAttentionSelection__RenderFunc(props: {
  variants: PlasmicAttentionSelection__VariantsArgs;
  args: PlasmicAttentionSelection__ArgsType;
  overrides: PlasmicAttentionSelection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "saveButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.saveButton
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootsaveButton]: hasVariant($state, "saveButton", "saveButton")
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"attentionSelection"}
        data-plasmic-override={overrides.attentionSelection}
        hasGap={true}
        className={classNames(projectcss.all, sty.attentionSelection, {
          [sty.attentionSelectionsaveButton]: hasVariant(
            $state,
            "saveButton",
            "saveButton"
          )
        })}
      >
        <div
          data-plasmic-name={"attentionPriorityLevels"}
          data-plasmic-override={overrides.attentionPriorityLevels}
          className={classNames(projectcss.all, sty.attentionPriorityLevels, {
            [sty.attentionPriorityLevelssaveButton]: hasVariant(
              $state,
              "saveButton",
              "saveButton"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__z1FFd
            )}
          >
            {"inactive"}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__h39Cg
            )}
          >
            {"rare"}
          </div>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__qvhLl
            )}
          >
            {"high priority"}
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"bars"}
            data-plasmic-override={overrides.bars}
            hasGap={true}
            className={classNames(projectcss.all, sty.bars)}
          >
            <AttentionSelectionElement
              data-plasmic-name={"grey"}
              data-plasmic-override={overrides.grey}
              className={classNames("__wab_instance", sty.grey)}
              colors={"dark"}
              deselected={true}
            />

            <AttentionSelectionElement
              data-plasmic-name={"yellow"}
              data-plasmic-override={overrides.yellow}
              className={classNames("__wab_instance", sty.yellow)}
              colors={"yellow"}
              deselected={true}
            />

            <AttentionSelectionElement
              data-plasmic-name={"orange"}
              data-plasmic-override={overrides.orange}
              className={classNames("__wab_instance", sty.orange)}
              colors={"orange"}
              deselected={true}
            />

            <AttentionSelectionElement
              data-plasmic-name={"red"}
              data-plasmic-override={overrides.red}
              className={classNames("__wab_instance", sty.red)}
              colors={"red"}
              deselected={true}
            />

            <AttentionSelectionElement
              data-plasmic-name={"purple"}
              data-plasmic-override={overrides.purple}
              className={classNames("__wab_instance", sty.purple)}
            />
          </p.Stack>
        </div>
        <Iconinfo2Icon
          data-plasmic-name={"infoButton"}
          data-plasmic-override={overrides.infoButton}
          className={classNames(projectcss.all, sty.infoButton)}
          role={"img"}
        />
      </p.Stack>
      {(hasVariant($state, "saveButton", "saveButton") ? true : false) ? (
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__pSyEi,
            {
              [sty.textsaveButton__pSyEia2HFy]: hasVariant(
                $state,
                "saveButton",
                "saveButton"
              )
            }
          )}
        >
          {hasVariant($state, "saveButton", "saveButton")
            ? "save"
            : "Enter some text"}
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "attentionSelection",
    "attentionPriorityLevels",
    "bars",
    "grey",
    "yellow",
    "orange",
    "red",
    "purple",
    "infoButton"
  ],
  attentionSelection: [
    "attentionSelection",
    "attentionPriorityLevels",
    "bars",
    "grey",
    "yellow",
    "orange",
    "red",
    "purple",
    "infoButton"
  ],
  attentionPriorityLevels: [
    "attentionPriorityLevels",
    "bars",
    "grey",
    "yellow",
    "orange",
    "red",
    "purple"
  ],
  bars: ["bars", "grey", "yellow", "orange", "red", "purple"],
  grey: ["grey"],
  yellow: ["yellow"],
  orange: ["orange"],
  red: ["red"],
  purple: ["purple"],
  infoButton: ["infoButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  attentionSelection: "div";
  attentionPriorityLevels: "div";
  bars: "div";
  grey: typeof AttentionSelectionElement;
  yellow: typeof AttentionSelectionElement;
  orange: typeof AttentionSelectionElement;
  red: typeof AttentionSelectionElement;
  purple: typeof AttentionSelectionElement;
  infoButton: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAttentionSelection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAttentionSelection__VariantsArgs;
    args?: PlasmicAttentionSelection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAttentionSelection__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAttentionSelection__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAttentionSelection__ArgProps,
          internalVariantPropNames: PlasmicAttentionSelection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAttentionSelection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAttentionSelection";
  } else {
    func.displayName = `PlasmicAttentionSelection.${nodeName}`;
  }
  return func;
}

export const PlasmicAttentionSelection = Object.assign(
  // Top-level PlasmicAttentionSelection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    attentionSelection: makeNodeComponent("attentionSelection"),
    attentionPriorityLevels: makeNodeComponent("attentionPriorityLevels"),
    bars: makeNodeComponent("bars"),
    grey: makeNodeComponent("grey"),
    yellow: makeNodeComponent("yellow"),
    orange: makeNodeComponent("orange"),
    red: makeNodeComponent("red"),
    purple: makeNodeComponent("purple"),
    infoButton: makeNodeComponent("infoButton"),

    // Metadata about props expected for PlasmicAttentionSelection
    internalVariantProps: PlasmicAttentionSelection__VariantProps,
    internalArgProps: PlasmicAttentionSelection__ArgProps
  }
);

export default PlasmicAttentionSelection;
/* prettier-ignore-end */
